<ng-container *ngIf="Tooltip">
    <p [title]="(Date | date: 'HH:mm:ss' )">
        {{(Date | date: 'dd/MM/yyyy') || '--'}}
    </p>
</ng-container>
<ng-container *ngIf="!Tooltip">
    <p>
        {{(Date | date: 'dd/MM/yyyy') || '--'}}
    </p>
</ng-container>